import React, { useContext } from 'react';
import { compose, omit } from 'ramda';
import { branch, lifecycle, mapProps, defaultProps } from 'recompose';
import { CategoryContext } from '../context';

export default () => branch(
    props => props.withBounceInAnimation,
    compose(
        Wrapped => (props) => {
            const { lastAddedGameCode } = useContext(CategoryContext);
            const { code } = props;
            const shouldBounceInAnimated = lastAddedGameCode === code;

            return <Wrapped {...{ ...props, shouldBounceInAnimated }} />;
        },
        lifecycle({
            shouldComponentUpdate() {
                return false;
            }
        }),
        branch(
            props => props.shouldBounceInAnimated,
            defaultProps({
                animate: true
            })
        ),
        mapProps(omit(['cleanLastInteractedCategory', 'shouldBounceInAnimated']))
    )
);
